import { render, staticRenderFns } from "./YgList.vue?vue&type=template&id=0e82d1a4&"
import script from "./YgList.vue?vue&type=script&lang=js&"
export * from "./YgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports